import { Card, Divider, Fade, Grid, Icon, Modal, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import PropTypes from "prop-types";
import { useContext, useState } from "react";

import SoftButton from "components/SoftButton";
import { ConfirmarContext } from "context/ConfirmarContext";
import { useEffect } from "react";
import { valorAPesos } from "utils/formatters.js";
import AgregarProducto from "../ModalPedido/components/AgregarProducto.jsx";
import ListadoDetalles from "../ModalPedido/components/ListadoDetalles.jsx";
import ModalFacturar from "../ModalPedido/components/ModalFacturar.jsx";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "90%", sm: "70%", xxl: "60%" },
  overflowY: "auto",
  p: 3,
};

export default function ModalNuevoPedido({ open, handleClose }) {
  const { confirmar } = useContext(ConfirmarContext);

  const [total, setTotal] = useState(0);
  const [modalFacturar, setModalFacturar] = useState(false);
  const [pedido, setPedido] = useState({
    detalles: [],
  });
  // const { confirmar } = useContext(ConfirmarContext);

  const ejecutarAccion = (accion, item) => {
    switch (accion) {
      case "borrar":
        let index = (pedido?.detalles || []).findIndex(
          (detalle) =>
            detalle.producto.id == item.producto.id &&
            item.id === detalle.id &&
            detalle.estado === item.estado &&
            detalle.precio === item.precio &&
            detalle.cantidad === item.cantidad &&
            detalle.ingredientesQuitados?.length === item.ingredientesQuitados?.length &&
            detalle.ingredientesQuitados?.every((ingrediente) =>
              item.ingredientesQuitados?.find(
                (ingredienteItem) => ingredienteItem.id === ingrediente.id
              )
            ) &&
            detalle.horarioEntrega === item.horarioEntrega &&
            detalle.numeroComanda === item.numeroComanda
        );
        if (pedido.detalles?.[index].id) {
          let newDetalles = [...pedido.detalles];
          newDetalles[index] = {
            ...newDetalles[index],
            estado: "CANCELADO",
          };
          setPedido({
            ...pedido,
            detalles: newDetalles,
          });
        } else {
          let newDetalles = [...pedido.detalles];
          newDetalles.splice(index, 1);
          setPedido({
            ...pedido,
            detalles: newDetalles,
          });
        }
        break;
      case "listo":
        {
          let index = (pedido?.detalles || []).findIndex(
            (detalle) =>
              detalle.producto.id == item.producto.id &&
              item.id === detalle.id &&
              detalle.estado === item.estado &&
              detalle.precio === item.precio &&
              detalle.cantidad === item.cantidad &&
              detalle.ingredientesQuitados?.length === item.ingredientesQuitados?.length &&
              detalle.ingredientesQuitados?.every((ingrediente) =>
                item.ingredientesQuitados?.find(
                  (ingredienteItem) => ingredienteItem.id === ingrediente.id
                )
              ) &&
              detalle.horarioEntrega === item.horarioEntrega &&
              detalle.numeroComanda === item.numeroComanda
          );
          let newDetalles = [...pedido.detalles];
          newDetalles[index] = {
            ...newDetalles[index],
            estado: "ENTREGADO",
          };
          setPedido({
            ...pedido,
            detalles: newDetalles,
          });
        }
        break;
      case "pendientesListos":
        {
          let newDetalles = pedido?.detalles?.map((detalle) => {
            if (detalle.estado === "PENDIENTE") {
              return {
                ...detalle,
                estado: "ENTREGADO",
              };
            }
            return detalle;
          });
          setPedido({
            ...pedido,
            detalles: newDetalles,
          });
        }
        break;
      default:
        break;
    }
  };

  //Calculo de total
  useEffect(() => {
    let total = 0;
    pedido?.detalles?.forEach((detalle) => {
      if (detalle.estado !== "CANCELADO") {
        total += Number(detalle.precio) * detalle.cantidad;
      }
    });
    setTotal(total);
  }, [pedido.detalles]);

  const resetPedido = () => {
    confirmar({
      title: "Cancelar pedido",
      message: "¿Está seguro que desea cancelar?",
      icon: "warning",
      func: () => {
        handleClose();
      },
    });
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox>
            <SoftBox display="flex" justifyContent="space-between">
              <SoftBox>
                <SoftTypography variant="h6">Nuevo Pedido</SoftTypography>
              </SoftBox>
              <SoftBox display="flex" justifyContent="space-between">
                <SoftBox>
                  <Tooltip title="Cerrar" placement="top">
                    <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                      close
                    </Icon>
                  </Tooltip>
                </SoftBox>
              </SoftBox>
            </SoftBox>
            <SoftBox pt={2}>
              <AgregarProducto pedido={pedido} setPedido={setPedido} />
              <Divider />
              <Grid container pb={1} spacing={0.5}>
                <Grid item xs={12} display="flex" justifyContent="flex-end"></Grid>
                <Grid item xs={12}>
                  <ListadoDetalles detalles={pedido?.detalles} ejecutarAccion={ejecutarAccion} />
                </Grid>
                <Grid item xs={12}>
                  <SoftTypography variant="subtitle" fontWeight="bold">
                    Total: {valorAPesos(total)}
                  </SoftTypography>
                </Grid>
              </Grid>
              <SoftBox
                display={{
                  xs: "flex-row",
                  sm: "flex",
                }}
                justifyContent="flex-end"
                alignItems="center"
              >
                <SoftBox
                  display={{
                    xs: "flex-row",
                    sm: "flex",
                  }}
                  justifyContent="end"
                  alignItems="center"
                >
                  <SoftBox
                    mr={{
                      xs: 0,
                      sm: 2,
                    }}
                    mt={{
                      xs: 2,
                      sm: 0,
                    }}
                  >
                    <SoftButton
                      color="primary"
                      circular
                      fullWidth={{
                        xs: true,
                        sm: false,
                      }}
                      onClick={resetPedido}
                    >
                      <Icon sx={{ fontWeight: "light" }}>cancel</Icon>
                      &nbsp;Cancelar
                    </SoftButton>
                  </SoftBox>
                  <SoftBox
                    mt={{
                      xs: 2,
                      sm: 0,
                    }}
                  >
                    <SoftButton
                      color="success"
                      circular
                      disabled={!pedido?.detalles?.length}
                      onClick={() => {
                        setModalFacturar(true);
                      }}
                      fullWidth={{
                        xs: true,
                        sm: false,
                      }}
                      // disabled={loadingSave || !mesaElegida?.pedido?.id}
                    >
                      <Icon sx={{ fontWeight: "light" }}>done_all</Icon>
                      &nbsp;Finalizar
                    </SoftButton>
                  </SoftBox>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          </SoftBox>
          <ModalFacturar
            open={modalFacturar}
            handleClose={() => {
              setModalFacturar(false);
            }}
            cerrarVenta={() => {
              setPedido({
                detalles: [],
              });
            }}
            total={total}
            pedido={pedido}
          />
        </Card>
      </Fade>
    </Modal>
  );
}

ModalNuevoPedido.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  refetch: PropTypes.func,
};
